module.exports = __webpack_public_path__ + "img/jigsaw-sessions.1af26a35.svg";